// extracted by mini-css-extract-plugin
module.exports = {"item":"Style_item__2lFsR","title":"Style_title__3-niJ","detail":"Style_detail__33SKy","options":"Style_options__u2JOZ"};